import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";
import {closest} from "@elements/dom-utils";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import Tabs from 'bootstrap/js/dist/tab';
onFind('[data-bs-toggle="tab"]',function (element) {
    new Tabs(element);
});

import Alert from 'bootstrap/js/dist/alert';
onFind('.alert',function (element) {
    new Alert(element);
});

import Popover from 'bootstrap/js/dist/popover';
onFind('[data-bs-toggle="popover"]',function (element) {
    if (element.getAttribute('data-content-url')) {
        new Popover(element, {
            trigger: 'focus',
            container: closest('.modal', element) ? closest('.modal', element) : 'body',
            html: true,
            content: '<div class="js-dynamic-modal__content"><div class="loading-overlay loading-overlay--content js-dynamic-modal__loading" hidden><div><div class="loading-spinner"><div class="loading-spinner__item loading-spinner__item--1"></div><div class="loading-spinner__item loading-spinner__item--2"></div><div class="loading-spinner__item loading-spinner__item--3"></div></div></div></div></div>',
            template: '<div class="popover popover--lg js-dynamic-popover" role="tooltip">' +
                '<div class="popover-arrow"></div>' +
                '<h3 class="popover-header"></h3>' +
                '<div class="popover-body">' +
                '</div></div>'
        });
    } else {
        new Popover(element);
    }
});

import * as fileInput from '@elements/file-input';
fileInput.init();

import * as dynamicModal from './scripts/dynamic-modal'
dynamicModal.init();

import * as terracePlaner from './scripts/terrace-planner/index'
terracePlaner.init();

import * as terracePlanerList from './scripts/terrace-planner/list'
terracePlanerList.init();

import * as terracePlanerPdf from './scripts/terrace-planner/pdf'
terracePlanerPdf.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as products from './scripts/product-item'
products.init();

import * as formValidation from '@elements/form-validation';
formValidation.init();

import * as productNumberSpinner from './scripts/product-number-spinner'
productNumberSpinner.init();

import * as affix from "@elements/affix";
affix.init({mediaQuery: '(min-width: 768px)'});

import * as postalCodeMapping from './scripts/postal-code-mapping'
postalCodeMapping.init();
